<template>
  <div>
    <v-snackbar v-model="msg" :color="color" top :vertical="true">
      {{ text }}
      <template v-slot:action="{ attrs }">
        <v-btn dark color="white" text v-bind="attrs" @click="msg = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-dialog
      v-model="dialog"
      max-width="300px"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card flat>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              dark
              text
              @click="onUploadImages"
              :disabled="isLoading || !deviceId"
              v-if="!fileAttached"
            >
              {{ isLoading ? "Uploading..." : "Upload" }}
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-alert
          border="top"
          colored-border
          type="error"
          elevation="2"
          class="ma-4"
          v-if="!deviceId"
        >
          There was no camera found. Please grant the browser access to your
          device's camera via the settings menu on your phone.
        </v-alert>

        <v-alert
          border="top"
          colored-border
          type="info"
          elevation="2"
          class="ma-4"
          v-if="fileAttached"
        >
          You've already included Body Check Images. Please review the images
          attached.
        </v-alert>

        <v-card-text class="pa-0 ma-0 overflow-x-hidden">
          <v-row justify="center" class="mt-1 pa-5" v-show="!fileAttached">
            <div class="main-camera ml-0">
              <vue-web-cam
                ref="webcam"
                :device-id="deviceId"
                width="100%"
                @started="onStarted"
                @cameras="onCameras"
                @camera-change="onCameraChange"
              />
              <span class="captured-image white--text">{{ types[typeIndex] }}</span>
              <div class="camera-options">
                <v-btn class="mx-2" fab dark color="primary" @click="onCapture">
                  <v-icon dark> mdi-camera-outline </v-icon>
                </v-btn>
              </div>
            </div>
          </v-row>
          <v-row justify="center" v-show="!fileAttached">
            <select v-model="camera">
              <option>-- Select Device --</option>
              <option
                v-for="device in devices"
                :key="device.deviceId"
                :value="device.deviceId"
                style="text-align: center"
              >
                {{ device.label }}
              </option>
            </select>
          </v-row>
          <v-card class="ma-4 mt-10">
            <v-row class="ma-4">
              <template v-for="image in images">
                <v-col :key="image.type" cols="12" md="3" sm="6">
                  <div class="text-center">
                    <div class="image-container">
                      <img :src="image.img" height="200" width="250" />
                      <div class="image-container-text">
                        <span>{{ image.type }}</span>
                      </div>
                    </div>
                  </div>
                </v-col>
              </template>
            </v-row>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
/*eslint-disable */
import { WebCam } from "vue-web-cam";
import renameFileHelper from "../../../mixins/renameFileHelper";
import AdlService from "../../../service/adl.service";
import FileUploadPreview from "./FileUploadPreview.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
const momentTz = require("moment-timezone");

export default {
  mixins: [renameFileHelper],
  props: {
    isUpdate: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    FileUploadPreview,
    "vue-web-cam": WebCam,
  },
  data() {
    return {
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false,
      img: null,
      camera: null,
      deviceId: null,
      devices: [],
      images: [],
      captureIndex: 0,
      files: [],
      service: "",
      skinCheckUploadProgress: 0,
      msg: false,
      color: "",
      text: "",
      selectFrontUpperBody: null,
      imagePreview: undefined,
      isLoading: false,
      fileAttached: 0,
      types: ["Front Upper Body", "Front Lower Body",  "Back Upper Body",  "Back Lower Body"],
      typeIndex: 0
    };
  },
  computed: {
    device() {
      return this.devices.find((n) => n.deviceId === this.deviceId);
    },
  },
  watch: {
    camera(id) {
      this.deviceId = id;
    },
    devices() {
      const [first, second, ...tail] = this.devices;
      if (second) {
        this.camera = second.deviceId;
        this.deviceId = second.deviceId;
      }else{
        this.camera = first.deviceId;
        this.deviceId = first.deviceId;
      }
    },
  },
  computed: {
    ...mapGetters("timezones", ["getDefaultTz"]),

    clientName() {
      return this.$store.state.clients.client.Name;
    },
  },

  methods: {
    ...mapActions({
      viewImages: "adl/viewImages",
      updateADLImage: "adl/updateADLImage",
    }),

    ...mapMutations({
      setDialog: "services/SET_DIALOG",
    }),

    openDialog(serv) {
      try {
        this.service = serv;
        this.dialog = !this.dialog;
        this.viewAdlImageUploads(serv);
        this.$refs.webcam.start();
      } catch (error) {}
    },
    async onCapture() {
      if (this.deviceId === null) {
        return alert("Please allow camera to capture images.");
      }
      if (this.images.length > 3) {
        return alert("Please upload captured images.");
      }

      this.captureIndex++;
      this.img = this.$refs.webcam.capture();

      var capturedImages = {};

      switch (this.captureIndex) {
        case 1: //front upper body
          capturedImages = {
            img: this.img,
            type: this.types[this.captureIndex - 1],
          };
          break;
        case 2: //front lower body
          capturedImages = {
            img: this.img,
            type: this.types[this.captureIndex - 1],
          };
          break;
        case 3: //back upper body
          capturedImages = {
            img: this.img,
            type: this.types[this.captureIndex - 1],
          };
          break;
        case 4: //back lower body
          capturedImages = {
            img: this.img,
            type: this.types[this.captureIndex - 1],
          };
          break;
        default:
          break;
      }
      this.images.push(capturedImages);
      this.typeIndex = this.captureIndex

    },
    onStarted(stream) {
      console.log("On Started Event", stream);
    },
    onCameras(cameras) {
      this.devices = cameras;
      console.log("On Cameras Event", cameras);
    },
    onCameraChange(deviceId) {
      this.deviceId = deviceId;
      this.camera = deviceId;
      console.log("On Camera Change Event", deviceId);
    },
    async onUploadImages() {
      if (this.images.length < 4) {
        return alert(`Please take a picture of ${this.types[this.typeIndex]}`);
      }

      this.isLoading = true;
      const { _id, scheduleTime, ServiceItem, ClientID, adlId } = this.service;

      const service = {
        category: ServiceItem,
        service_id: _id,
        scheduleTime: scheduleTime,
        date: this.isUpdate ? this.service.date : new Date(),
        clientID: ClientID,
        adlId
      };

      const skinCheckImages = {
        frontUpperBody: await this.converDataUriToFile(
          this.images[0].img,
          this.images[0].type
        ),
        frontLowerBody: await this.converDataUriToFile(
          this.images[1].img,
          this.images[1].type
        ),
        backUpperBody: await this.converDataUriToFile(
          this.images[2].img,
          this.images[2].type
        ),
        backLowerBody: await this.converDataUriToFile(
          this.images[3].img,
          this.images[3].type
        ),
      };

      try {
        const response = await AdlService.uploadSkinCheckImage(
          { ...service, tz: momentTz.tz.guess() },
          skinCheckImages,
          this.showSkinCheckUploadProgress
        );
        this.messageDialog(
          true,
          "success",
          "Body check image(s) successfully uploaded."
        );
        this.isLoading = false;
        this.dialog = false;

        if (this.isUpdate) {
          const document = response.data.servicePlan;
          const adlResponse = await this.updateADLImage({
            id: adlId,
            data: document._id,
          });

          this.setDialog(false);
        }
      } catch (error) {
        console.log(error);
        this.messageDialog(
          true,
          "red accent-2",
          "Failed to upload body check image(s)."
        );
        this.isLoading = false;
        this.setDialog(false);
      }
    },

    async converDataUriToFile(url, filename) {
      let ext = "jpg";
      const byteString = atob(url.split(",")[1]);
      const mimeString = url.split(",")[0].split(":")[1].split(";")[0];
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i += 1) {
        ia[i] = byteString.charCodeAt(i);
      }
      const blob = new Blob([ab], { type: mimeString });
      // const file = new File([blob], `test.jpg`, { type: mimeString });
      const file = await this.renameFileHelper(
        new File([blob], `${filename}.${ext}`, {
          type: mimeString,
        }),
        this.clientName,
        "skin-check"
      );
      return file;
    },

    async viewAdlImageUploads(serv) {
      const data = {
        service_id: serv._id,
        scheduleTime: serv.scheduleTime,
        date: this.isUpdate ? this.service.date : new Date(),
        clientID: serv.ClientID,
        tz: this.getDefaultTz,
      };
      let adlImage = await this.viewImages(data);
      this.fileAttached = adlImage.data.length;
    },

    messageDialog(msg, color, text) {
      this.msg = msg;
      this.color = color;
      this.text = text;
    },

    close() {
      this.dialog = false;
      this.clear();
    },

    clear() {
      this.$refs.webcam.stop();
      this.images = [];
      this.captureIndex = 0;
    },
  },
};
</script>

<style scoped>
.main-camera {
  position: relative;
}

.camera-options {
  position: absolute;
  bottom: 30px;
  left: 0;
  width: 100%;
  text-align: center;
  color: aliceblue;
}

.image-container {
  position: relative;
}

.image-container-text {
  position: absolute;
  bottom: 3px;
  left: 50%;
  text-align: center;
  color: aliceblue;
  transform: translate(-50%, -50%);
}

.v-dialog > .v-card > .v-toolbar {
  position: sticky;
  top: 0;
  z-index: 999;
}

.captured-image{
 position: absolute;
 top: 5%;
 left: 50%;
 transform: translateX(-50%);
}
</style>
